import { EndpointCategory } from './types'

export const webviewCategories: EndpointCategory[] = [
    {
        id: 'webview-introduction',
        title: {
            pt: 'Introdução',
            en: 'Introduction'
        },
        description: {
            pt: 'O Webview EmpreX é uma interface web completa para solicitação de empréstimos que pode ser integrada em aplicativos de parceiros via WebView ou iFrame.',
            en: 'The EmpreX Webview is a complete web interface for loan requests that can be integrated into partner applications via WebView or iFrame.'
        },
        endpoints: []
    },
    {
        id: 'webview-admin-api',
        title: {
            pt: 'API Administrativa',
            en: 'Admin API'
        },
        description: {
            pt: 'Para usar o Webview, você precisa implementar apenas os endpoints da Admin API.',
            en: 'To use the Webview, you only need to implement Admin API endpoints.'
        },
        endpoints: []
    },
    {
        id: 'webview-integration',
        title: {
            pt: 'Integração',
            en: 'Integration'
        },
        description: {
            pt: 'Como integrar o Webview no seu aplicativo ou site.',
            en: 'How to integrate the Webview into your application or website.'
        },
        endpoints: []
    },
    {
        id: 'webview-parameters',
        title: {
            pt: 'Parâmetros',
            en: 'Parameters'
        },
        description: {
            pt: 'Parâmetros de URL disponíveis para configuração do Webview.',
            en: 'Available URL parameters for Webview configuration.'
        },
        endpoints: []
    },
    {
        id: 'webview-callbacks',
        title: {
            pt: 'Callbacks',
            en: 'Callbacks'
        },
        description: {
            pt: 'Como receber notificações sobre eventos do Webview.',
            en: 'How to receive notifications about Webview events.'
        },
        endpoints: []
    },
    {
        id: 'webview-flow',
        title: {
            pt: 'Fluxo do Usuário',
            en: 'User Flow'
        },
        description: {
            pt: 'Etapas que o usuário percorre durante o processo de solicitação de empréstimo.',
            en: 'Steps that the user goes through during the loan request process.'
        },
        endpoints: []
    },
    {
        id: 'webview-customization',
        title: {
            pt: 'Customização',
            en: 'Customization'
        },
        description: {
            pt: 'Opções de personalização visual do Webview.',
            en: 'Webview visual customization options.'
        },
        endpoints: []
    },
    {
        id: 'webview-security',
        title: {
            pt: 'Segurança',
            en: 'Security'
        },
        description: {
            pt: 'Práticas de segurança e considerações importantes.',
            en: 'Security practices and important considerations.'
        },
        endpoints: []
    }
]
